import { PlatformProductCategory } from '~/graphql/graphql';
import {
  filterRowsToSaved,
  readSavedFilterRows,
  type SavedFilterRowSchema,
} from '~/types/filters';
import {
  isPropertyField,
  operatorsForField,
  type ProductFilterRow,
} from './filterClauses';
import type { MyProductsFilterViewConfig } from './filterViews';
import {
  categoryOf,
  withCategory,
  withoutCategory,
} from './myProductsFilterRows';

const CATEGORIES: readonly string[] = Object.values(PlatformProductCategory);

function savedRowSchema(
  config: MyProductsFilterViewConfig
): SavedFilterRowSchema {
  return {
    operatorsForField: (field) => {
      const outsideView =
        !isPropertyField(field) &&
        config.fields !== undefined &&
        !config.fields.includes(field);
      return outsideView ? null : operatorsForField(field);
    },
    isListField: () => false,
  };
}

export function myProductsRowsToFilterData(
  rows: ProductFilterRow[],
  rowsKey: string
): Record<string, unknown> {
  const category = categoryOf(rows);
  return {
    [rowsKey]: filterRowsToSaved(withoutCategory(rows)),
    ...(category ? { category } : {}),
  };
}

export function readMyProductsFilterRows(
  filterData: unknown,
  config: MyProductsFilterViewConfig
): ProductFilterRow[] {
  if (typeof filterData !== 'object' || filterData === null) return [];
  const stored = filterData as Record<string, unknown>;
  const rows = readSavedFilterRows(
    stored[config.rowsKey],
    savedRowSchema(config)
  );
  const category =
    typeof stored.category === 'string' && CATEGORIES.includes(stored.category)
      ? stored.category
      : undefined;
  return withCategory(rows, category);
}
